import { useCallback } from 'react'

import { useSegment } from '../../../hooks'

export const useTrackQuickStart = () => {
  const { track } = useSegment()

  const trackQuickStart = useCallback(
    (event: string) => {
      track(event)
    },
    [track],
  )

  return { trackQuickStart }
}
